

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"
import DataTable from "../DataTable.vue"
import FieldPermissions from "../Permissions/FieldPermissions.vue"
import UserImage from "../../UserImage.vue"
import SourceSearch from "./SourceSearch.vue"

import { TemplateDetails, Field, DataDefinition, FieldInstance } from "@/types"
import User from "@/types/user"

import api from "@/services/api"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"user-image": UserImage,
		"source-search": SourceSearch
	}
})
export default class SourceSetup extends Vue {
	@Getter("getMe")
	public me!: User;

	public definitions: DataDefinition[] = [];
	public definition: DataDefinition | null = null;

	public get columns (): any[] {
		return [
			{
				key: "title",
				label: "Title",
				sortable: true,
				errors: (item: any) => item.title ? null : "Please enter a title"
			},
			{
				key: "definitionTitle",
				label: "Item Type",
				sortable: true,
				dataType: "list",
				valueColumn: "definitionId",
				options: this.definitions
			},
			{
				key: "includedLists",
				label: "Included Lists",
				dataType: "list-multiple",
				valueColumn: "includedLists",
				options: this.dataSources,
				hasTemplate: true
			},
			{
				key: "createdBy.name",
				label: "Created By",
				inModal: (item: any) => false,
				hasTemplate: true
			},
			{
				key: "lastUpdated",
				label: "Last Updated",
				inModal: (item: any) => false,
				hasTemplate: true
			},
			{
				key: "buttons",
				label: "",
				inModal: (item: any) => false,
				hasTemplate: true
			}
		]
	}

	public searchDataSource: any = null;
	public showSearch: boolean = false;

	public dataSources: any[] = [];

	loading: boolean = false;

	public async mounted () {
		this.definitions = await api.definitions()
		this.loadSources()
	}

	async loadSources (): Promise<void> {
		this.loading = true
		this.dataSources = (await api.dataSources())

		this.loading = false
	}

	async save (souce: any) {
		await api.dataSourceSave(souce)
		this.loadSources()
	}

	async deleteField (field: Field) {
		// await api.fieldDelete(field);
		this.loadSources()
	}

	createNewItem () {
		return { }
	}

	async deleteDetails (item: Field) {
		// return await api.fieldUsage(item);
	}

	viewItems (source: any) {
		this.searchDataSource = source
	}
}
